import { render, staticRenderFns } from "./copyBroadcastDialog.vue?vue&type=template&id=0ebd45e4&"
import script from "./copyBroadcastDialog.vue?vue&type=script&lang=js&"
export * from "./copyBroadcastDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports